import React from "react";
import {Space, Typography} from "antd";
import {Link} from "react-router-dom";
import {Translate} from "../../../../hooks/translate.hook";
import {
    HealthCheckerIncident,
    HealthCheckerIssue,
} from "../../../../models/health-checker/health-checker";
import {formatHealthCenterDateTime} from "../../health-center.helpers";
import {HealthCenterIssueStatus} from "./issues.status";
import {SmartColumn} from "../../../common/smart-table/smart-table.model";
import {FieldType} from "../../../common/smart-table/smart-table.field-config";

const {Paragraph, Text} = Typography;

export const columnsFactory = (
    t: Translate
): SmartColumn<HealthCheckerIssue>[] => {
    return [
        {
            visibleName: t("HEALTH-CENTER.ISSUES.ID", {defaultValue: "Issue"}),
            name: "id",
            type: FieldType.INTEGER,
            render: (id: number) => (
                <Link className="health-center-issues__id" to={`/health-center/issues/${id}`}>
                    #{id}
                </Link>
            ),
        },
        {
            visibleName: t("HEALTH-CENTER.ISSUES.STATUS", {defaultValue: "Status"}),
            name: "status",
            type: FieldType.STRING,
            filterable: true,
            render: (status: string) => <HealthCenterIssueStatus status={status} />,
        },
        {
            visibleName: t("HEALTH-CENTER.ISSUES.CHECK", {defaultValue: "Check"}),
            name: "check",
            dataIndex: ["check", "checkerName"],
            type: FieldType.STRING,
            filterable: true,
            render: (checkerName: string) => <Text strong>{checkerName}</Text>,
        },
        {
            visibleName: t("HEALTH-CENTER.ISSUES.DESCRIPTION", {defaultValue: "Description"}),
            name: "description",
            type: FieldType.STRING,
            render: (description: string) => (
                <Paragraph
                    className="health-center-issues__description"
                    ellipsis={{rows: 2, tooltip: description}}
                >
                    {description}
                </Paragraph>
            ),
        },
        {
            visibleName: t("HEALTH-CENTER.ISSUES.CREATED-AT", {defaultValue: "Created"}),
            name: "createdAt",
            type: FieldType.DATETIME,
            filterable: true,
            render: (createdAt: string) => (
                <Text className="health-center-issues__date">{formatHealthCenterDateTime(createdAt)}</Text>
            ),
        },
        {
            visibleName: t("HEALTH-CENTER.ISSUES.LAST-INCIDENT", {defaultValue: "Last incident"}),
            name: "lastIncident",
            type: FieldType.CUSTOM,
            render: (incident: HealthCheckerIncident) => (
                <Space direction="vertical" size={2}>
                    <Space size={8} wrap>
                        <Text strong>#{incident.id}</Text>
                        <Text className="health-center-issues__date">
                            {formatHealthCenterDateTime(incident.createdAt)}
                        </Text>
                    </Space>
                    <Paragraph
                        className="health-center-issues__description health-center-issues__description--incident"
                        ellipsis={{rows: 2, tooltip: incident.description}}
                    >
                        {incident.description}
                    </Paragraph>
                </Space>
            ),
        },
    ];
};
